<div class="container">
    <div class="h1">Les différents services de La Maison d'Assurance du Centre Est</div>
    <div class="services">
        <div class="service" (click)="nav.nav('assurance-auto')">
            <div class="titre">Assurance automobile</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/assurance-auto-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/assurance-auto-pt.png" alt="auto">
                </picture>
            </div>
            <div class="bouton">Assurance auto</div>
        </div>
        <div class="service" (click)="nav.nav('assurance-habitation')">
            <div class="titre">Assurance habitation</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/assurance-habitation-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/assurance-habitation-pt.png" alt="maison">
                </picture>
            </div>
            <div class="bouton">Assurance habitation</div>
        </div>
        <div class="service" (click)="nav.nav('assurance-sante')">
            <div class="titre">Assurance santé</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/assurance-sante-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/assurance-sante-pt.png" alt="santé">
                </picture>
            </div>
            <div class="bouton">Assurance santé</div>
        </div>
        <div class="service" (click)="nav.nav('assurance-pret')">
            <div class="titre">Assurance prêt</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/assurance-pret-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/assurance-pret-pt.png" alt="pret">
                </picture>
            </div>
            <div class="bouton">Assurance prêt</div>
        </div>
        <div class="service" (click)="nav.nav('assurance-professionnelle')">
            <div class="titre">Assurance professionnelle</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/assurance-pro-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/assurance-pro-pt.png" alt="pro">
                </picture>
            </div>
            <div class="bouton">Assurance professionnelle</div>
        </div>
        <div class="service" (click)="nav.nav('assurance-accidents')">
            <div class="titre">Assurance accidents de la vie</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/assurance-accident-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/assurance-accident-pt.png" alt="accidents">
                </picture>
            </div>
            <div class="bouton">Assurance accidents de la vie</div>
        </div>
        <div class="service" (click)="nav.nav('cryptomonnaies')">
            <div class="titre">Cryptomonnaies</div>
            <div class="image">
                <picture>
                        <!-- WebP -->
                        <source
                            type="image/webp"
                            srcset="./../../../assets/webp/crypto-pt-333.webp"
                            alt="tel"
                        >
                        <!-- Fallback -->
                        <img src="./../../../assets/crypto-pt.png" alt="bitcoin">
                </picture>
            </div>
            <div class="bouton">Cryptomonnaies</div>
        </div>
    </div>
</div>